import React from "react";
import PropTypes from "prop-types";
//Material imports
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import makeStyles from "@mui/styles/makeStyles";
import SectionHeader from "../section-header/SectionHeader";
import MediaContent from "../media-content/MediaContent";
const useStyles = makeStyles(theme => ({
  container: {
    ...theme.grid.gridTemplateContainer,
    gridTemplateAreas: `"media"
                            "text"`,
    textAlign: "center",
    minWidth: 100,
    paddingTop: 5,
    gap: "20px 0px"
  },
  mediaContainer: {
    display: "flex",
    justifyContent: "flex-start",
    gridArea: "media"
  },
  textContainer: {
    gridArea: "text"
  },
  paperStyles: {
    borderRadius: 12,
    padding: 32,
    wordBreak: "break-word"
  },
  quote: {
    fontSize: 31,
    lineHeight: 1
  },
  contentText: {
    padding: "24px 0px"
  },
  [theme.breakpoints.up("md")]: {
    quote: {
      fontSize: 55
    }
  },
  [theme.breakpoints.up("sm")]: {
    container: {
      gridTemplateAreas: `
                                "text media"
                                `,
      gridTemplateColumns: "1fr 1fr",
      columnGap: 36,
      textAlign: "left"
    }
  },
  [theme.breakpoints.down('sm')]: {
    mediaContainer: {
      justifyContent: "center"
    }
  }
}));
const TestimonialsWithMedia = ({
  content,
  leftSpaceContainer,
  bottomSpaceContainer = "",
  extraHeaderStyle = "",
  subHeaderContainer
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Grid, {
    className: `${leftSpaceContainer}  ${bottomSpaceContainer}`
  }, /*#__PURE__*/React.createElement(SectionHeader, {
    header: content.header,
    extraHeaderStyle: extraHeaderStyle
  }), /*#__PURE__*/React.createElement(Grid, {
    className: `${classes.container}`
  }, /*#__PURE__*/React.createElement(Grid, {
    className: `${subHeaderContainer} ${classes.textContainer}${classes.paperStyles}`
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 1,
    component: Typography,
    variant: "h2",
    className: classes.quote,
    color: "textPrimary"
  }, "\u201C"), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 11
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "textPrimary"
  }, content.subHeader), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "textPrimary",
    className: classes.contentText
  }, content.text), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    color: "textPrimary"
  }, content.author)))), /*#__PURE__*/React.createElement(Grid, {
    className: classes.mediaContainer
  }, /*#__PURE__*/React.createElement(MediaContent, {
    content: content,
    noImageUrl: content.images[0].url === ""
  }))));
};
TestimonialsWithMedia.propTypes = {
  content: PropTypes.object.isRequired,
  leftSpaceContainer: PropTypes.string,
  bottomSpaceContainer: PropTypes.string,
  extraHeaderStyle: PropTypes.string,
  subHeaderContainer: PropTypes.string
};
export default TestimonialsWithMedia;